"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _TabItem = _interopRequireDefault(require("./TabItem.style"));

var _index = _interopRequireDefault(require("../../Label/index"));

var _index2 = _interopRequireDefault(require("../../Icon/index"));

var _index3 = require("../../index");

var _dec, _class;

let TabItem = (_dec = (0, _reactJss.default)(_TabItem.default), _dec(_class = class TabItem extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const {
      value,
      visibility,
      onChange
    } = this.props;
    if (visibility === 'disabled') return;
    onChange(value);
  }

  render() {
    const {
      id,
      classes,
      value,
      visibility,
      leftIcon,
      rightIcon,
      leftIconSize,
      rightIconSize,
      children,
      label,
      size,
      type,
      error,
      activeItem,
      itemRef,
      className,
      tabItemIndent,
      color,
      dataTestId
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: itemRef,
      id: id,
      className: (0, _clsx.default)(className, classes.tab, classes[size], classes[type], classes[`indent${tabItemIndent}`], {
        error: !!error
      }, {
        disabled: visibility === 'disabled'
      }, {
        hidden: visibility === 'hidden'
      }, {
        active: activeItem === value
      }, {
        withCustomColor: !!color
      }, 'tabItem'),
      style: {
        color,
        borderBottomColor: color,
        background: color ? `linear-gradient(180deg, ${_index3.Utils.hexToRgba(color, 0)} 0%, ${_index3.Utils.hexToRgba(color, 0.12)} 100%)` : 'initial'
      },
      onClick: this.handleClick,
      "data-testid": dataTestId
    }, leftIcon && /*#__PURE__*/_react.default.createElement(_index2.default, {
      type: leftIcon,
      className: (0, _clsx.default)(classes.icon, classes.leftIcon, 'leftIcon'),
      size: leftIconSize
    }), label && /*#__PURE__*/_react.default.createElement(_index.default, {
      className: (0, _clsx.default)(classes.label),
      value: label,
      fontSize: size === 'small' ? 'small' : 'medium'
    }), rightIcon && /*#__PURE__*/_react.default.createElement(_index2.default, {
      type: rightIcon,
      className: (0, _clsx.default)(classes.icon, classes.rightIcon, 'rightIcon'),
      size: rightIconSize
    }), children ? /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(classes.children, 'tabChildren')
    }, children) : null);
  }

}) || _class);
TabItem.defaultProps = {
  id: null,
  error: false,
  visibility: 'visible',
  type: 'fixed',
  size: 'medium',
  tabItemIndent: 'medium',
  leftIconSize: 'small',
  rightIconSize: 'small',
  onChange: () => {}
};
var _default = TabItem;
exports.default = _default;